module.exports = __webpack_public_path__ + "img/v3.980d8363.png";